import React, {useEffect, useState} from "react";
import {useEventContext} from "../../../../context";
import {eventStatisticBannersGet} from "../../../../../api/cp";
import Loading from "../../../Loading";
import Banners from "./Banners";

export default () => {
    const {event} = useEventContext();
    const [banners, setBanners] = useState(null);

    useEffect(() => {
        eventStatisticBannersGet(event.eventPassword)
            .then(banners => setBanners(banners))
        ;
    }, []);

    if (null === banners) {
        return <Loading>Загрузка баннеров</Loading>
    }

    return (
        <Banners banners={banners} />
    );
};
